import {
  Component,
  OnInit,
  Input,
  ViewChild,
  ViewChildren,
  QueryList,
  AfterViewInit
} from '@angular/core';
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { ClientEventService, MessageService, ServerError } from '@radsource/ng-common-lib';

import { SeriesInstance } from '../../objects/series-instance';
import { SOPComponent } from '../sop/sop.component';
import { StudyInstance } from '../../objects/study-instance';
import { SOPInstance } from '../../objects/sop-instance';
import { InstanceService } from '../../services/instance.service';
import { DicomService } from '../../services/dicom.service';
import { of } from 'rxjs';

//This is a dependency of the Proton Xpress App Module
@Component({
  selector: 'series',
  templateUrl: './series.component.html',
  styleUrls: ['./series.component.scss'],
  animations: [
    trigger('rowOptions', [
      state('inactive', style({
        opacity: .5
      })),
      state('active', style({
        opacity: 1
      })),
      transition('inactive => active', animate('100ms ease-in')),
      transition('active => inactive', animate('100ms ease-out'))
    ])
  ]
})
export class SeriesComponent implements OnInit, AfterViewInit {

  @Input() series: SeriesInstance;
  @Input() study: StudyInstance;
  @Input() patientContainer: any;

  sops: Array<SOPInstance> = new Array<SOPInstance>();
  // expanded: Boolean = false;
  deleting: Boolean = false;

  sopDetail: SOPInstance = null;

  errorText: string = null;
  rowHover: string;
  showEdit: Boolean = false;
  showingDetailMenus: Boolean = false;

  popoverText: string = "";
  @ViewChild('t', { static: false }) public tooltip: NgbTooltip;
  @ViewChild('stateTip', { static: false }) public stateTip: NgbTooltip;

  @ViewChildren(SOPComponent) viewSOPs: QueryList<SOPComponent> = new QueryList<SOPComponent>();

  sops$: any;

  constructor(
    public is: InstanceService,
    public ces: ClientEventService,
    public domSanitizer: DomSanitizer,
    public ds: DicomService,
    public ms: MessageService
  ) { }

  ngAfterViewInit() {
    if (this.ds.pushing == false && this.ds.pushAttempted == false) {
      this.getThumbnail();
    }
  }

  ngOnInit() {
    this.rowHover = 'inactive';
  }

  closePopover() {
    this.popoverText = '';
    this.tooltip.close();
  }

  expandPopover() {
    (this.series.expanded == false) ? this.popoverText = 'Show Images' : this.popoverText = 'Hide Images';
    this.tooltip.open(this.popoverText);
  }

  toggleSeries() {
    this.series.expanded = !this.series.expanded;
    this.series.expanded$ = of(this.series.expanded);
    this.expandPopover();
  }

  getThumbnail() {
    if (this.series.thumbnail) {
      return;
    }
    // this.series.loadingThumbnail = true;
    this.is.retrieveSeriesThumbnail(this.series.record_id, this.patientContainer.nativeElement.offsetHeight)
      .then((res) => {
        if (res.error.length > 0) {
          throw Error(res.error);
        }
        this.series.thumbnail = res;
        this.series.thumbnail$ = of(this.series.thumbnail);
        // this.series.loadingThumbnail = false;
      }).catch((err) => {
        this.ms.handleServerError(new ServerError(err));
      });
  }

  getThumbnails() {
    this.series.sops.forEach((so) => {
      if (!so.thumbnail) {
        so.loadingThumbnail = true;
        this.is.retrieveSOPThumbnailAsOwner(so.record_id, this.patientContainer.nativeElement.offsetHeight)
          .then((res) => {
            so.thumbnail = res;
            so.loadingThumbnail = false;
          }).catch((err) => {
            so.loadingThumbnail = false;
          });
      }
    });
  }

  toggleRowHover(hoverState) {
    this.rowHover = hoverState;
  }

  setSOPDetail(sop: any) {
    let viewSOPs = this.viewSOPs.filter((so) => so.sop.record_id != sop.record_id);
    viewSOPs.forEach((sop) => { sop.detail = false; });
    let viewSOP = this.viewSOPs.find((so) => so.sop.record_id == sop.record_id);
    viewSOP.detail = !viewSOP.detail;
    viewSOP.detail$ = of(viewSOP.detail);
    this.sopDetail = (viewSOP.detail == true) ? sop : null;
  }

  delete(): any {
    this.deleting = true;
    this.is.deleteSeriesAsOwner(this.series)
      .then((res) => {
        this.deleting = false;
        this.ces.pushQueueDeletion.emit(this.series);
      }).catch((err) => {
        this.errorText = err;
      });
  }

  edit() {
    this.is.clearEditing();
    this.series.editing = true;
    this.is.editSeries(this.series);
  }

  closeEdit() {
    this.is.clearEditing();
    this.is.closeEdit();
  }

  closeStatePopover() {
    this.stateTip.close();
  }

  expandStatePopover() {
    this.stateTip.open(this.series.pushProgress.state);
  }

  cleanURL() {
    return this.domSanitizer.bypassSecurityTrustResourceUrl('data:' + this.series.thumbnail.mimeType + ';' + this.series.thumbnail.encoding + ',' + this.series.thumbnail.image);
  }

}
